export default "<div class=\"loader-container\">\n  <img src=\"../../../assets/loading.gif\" alt=\"Cargando la información\">\n</div>\n";